export default __webpack_public_path__ + "static/mapmetrics-5e9f84fd8272d397c1b226b72c7ad4ba.svg";